const overviewTimeEnum = [
  {
    value: "today",
    label: "overview.filterTime.daily",
    label_tag: "overview.filterTime.daily",
    is_translation: true,
  },
  {
    value: "yesterday",
    label: "overview.filterTime.yesterday",
    label_tag: "overview.filterTime.yesterday",
    is_translation: true,
  },
  {
    value: "thisWeek",
    label: "overview.filterTime.thisWeek",
    label_tag: "overview.filterTime.thisWeek",
    is_translation: true,
  },
  {
    value: "lastWeek",
    label: "overview.filterTime.lastWeek",
    label_tag: "overview.filterTime.lastWeek",
    is_translation: true,
  },
  {
    value: "month",
    label: "overview.filterTime.monthly",
    label_tag: "overview.filterTime.monthly",
    is_translation: true,
  },
  {
    value: "lastMonth",
    label: "overview.filterTime.lastMonth",
    label_tag: "overview.filterTime.lastMonth",
    is_translation: true,
  },
];

export default overviewTimeEnum;
